import { Resource as a, API as s } from "@coveo/platform-client";
const t = class t extends a {
  /**
   * Rotate the customer key by deactivating any active key and activating the key with the given ID.
   *
   * @param customerKeyId The ID of the customer key to activate.
   */
  rotate(i) {
    return this.api.put(
      this.buildPath(`${t.baseUrl}/${i}/rotate`)
    );
  }
  /**
   * Deactivate a customer key.
   *
   * @param customerKeyId The ID of the customer key to deactivate.
   */
  deactivate(i) {
    return this.api.put(
      this.buildPath(`${t.baseUrl}/${i}/deactivate`)
    );
  }
  /**
   * Activate a customer key.
   *
   * @param customerKeyId The ID of the customer key to activate.
   */
  activate(i) {
    return this.api.put(
      this.buildPath(`${t.baseUrl}/${i}/activate`)
    );
  }
  /**
   * Get the list of customer keys in an organization.
   *
   * @returns The list of customer keys.
   */
  list() {
    return this.api.get(this.buildPath(`${t.baseUrl}`));
  }
  /**
   * Create a customer key.
   *
   * @param customerKey The details of the customer key to create.
   * @returns The created customer key.
   */
  create(i) {
    return this.api.post(this.buildPath(`${t.baseUrl}`), i);
  }
  /**
   * Get a customer key.
   *
   * @param customerKeyId The ID of the customer key to get.
   * @returns The details of the customer key.
   */
  get(i) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/${i}`)
    );
  }
  /**
   * Delete a customer key.
   *
   * @param customerKeyId The ID of the customer key to delete.
   */
  delete(i) {
    return this.api.delete(this.buildPath(`${t.baseUrl}/${i}`));
  }
  /**
   * Get a map between customer key IDs and their usage status.
   *
   * @returns A map between customer key IDs and their usage status.
   */
  inUse() {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/in-use`)
    );
  }
  /**
   * Get a map between customer key IDs and their validity status.
   *
   * @returns A map between customer key IDs and their validity status.
   */
  valid() {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/valid`)
    );
  }
};
t.baseUrl = `/rest/organizations/${s.orgPlaceholder}/customerkeys`;
let e = t;
export {
  e as OrganizationCustomerKeysResource
};
//# sourceMappingURL=OrganizationCustomerKeysResource.js.map
